/**
 * @generated SignedSource<<9c9a8b71e5b1e4c1ca57fa494ba1a6c1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationFeedsOrderBy = "name" | "total_comments" | "total_reactions" | "%future added value";
export type CreateMemberFeedsCSVDataInput = {
  canPost?: boolean | null;
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  orderBy?: OrganizationFeedsOrderBy | null;
  organizationMembershipId: string;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportFeedsTableExportCSVButtonMutation$variables = {
  input: CreateMemberFeedsCSVDataInput;
};
export type AdminMembersReportFeedsTableExportCSVButtonMutation$data = {
  readonly response: {
    readonly downloadCSVLink: string | null;
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
  };
};
export type AdminMembersReportFeedsTableExportCSVButtonMutation = {
  response: AdminMembersReportFeedsTableExportCSVButtonMutation$data;
  variables: AdminMembersReportFeedsTableExportCSVButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateMemberFeedsCSVDataResponse",
    "kind": "LinkedField",
    "name": "createMemberFeedsCSVData",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "downloadCSVLink",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportFeedsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AdminMembersReportFeedsTableExportCSVButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b0598442e93c502ea295a0ff9263218a",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportFeedsTableExportCSVButtonMutation",
    "operationKind": "mutation",
    "text": "mutation AdminMembersReportFeedsTableExportCSVButtonMutation(\n  $input: CreateMemberFeedsCSVDataInput!\n) {\n  response: createMemberFeedsCSVData(input: $input) {\n    downloadCSVLink\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b3afd2aa49a31dc3ff1b53a3bbeb578a";

export default node;
